<div [formGroup]="group" class="field" [ngClass]="{ hidden: field.hidden }">
    <label for="{{ field.name }}-{{ formId }}" id="label-{{ field.name }}-{{ formId }}" [class.active]="hasFocus">
        <span class="labelcontent fixed">{{ field.label }}<span *ngIf="field.required" class="is-required">*</span></span>
        <ng-container *ngIf="field.description">
            <span>{{ field.description }}</span>
        </ng-container>
        <div class="phonewrapper">
            <ng-container *ngIf="showCountrySelect$ | async">
                <select
                    id="{{ field.name }}_ext-{{ formId }}"
                    (change)="updatePhonePrefix($event.target.value)"
                    (focus)="hasFocus = true"
                    (blur)="hasFocus = false"
                >
                    <option
                        *ngFor="let country of countriesByCode"
                        [value]="country[0]"
                        [selected]="country[0] === preselectedCountry"
                    >
                        {{ country[1] }}
                    </option>
                </select>
                <div class="phonenumberwrapper">
                    <span class="phoneprefix">{{ phonePrefix$ | async }}</span>
                    <input
                        type="tel"
                        id="{{ field.name }}-{{ formId }}"
                        (change)="updatePhoneNumberValue($event)"
                        (blur)="validateField()"
                    />
                </div>
                <input [formControlName]="field.name" [type]="'hidden'" />
            </ng-container>
            <ng-container *ngIf="!(showCountrySelect$ | async)">
                <div class="phonenumberwrapper no-select">
                    <input type="tel" [formControlName]="field.name" id="{{ field.name }}-{{ formId }}" (blur)="validateField()" />
                </div>
            </ng-container>
        </div>
    </label>

    <ng-container *ngIf="showErrors$ | async">
        <ng-container *ngFor="let error of group.get(field.name).errors | getIterableErrors">
            <span class="error-msg">{{ getErrorTranslation(error) }}</span>
        </ng-container>
    </ng-container>
    <ng-container *ngFor="let dependentField of field.dependentFieldFilters">
        <ng-container *ngIf="getVisibilityByDependentFieldFiltersAndSetValidators(dependentField, group.get(field.name))">
            <div class="row">
                <ng-container
                    daDynamicField
                    [control]="dependentField.dependentFormField"
                    [reactiveFormData]="group"
                    [formId]="formId"
                ></ng-container>
            </div>
        </ng-container>
    </ng-container>
</div>
